import { TrackingRequestContext } from 'app/context/tracking-request';
import { useLazyGetTemplatesQuery } from 'app/features/templates/api';
import { useLazyLoadOption } from 'app/hooks/useLazyLoadOption';
import { useContext } from 'react';

export const useFetchLinkageTemplate = (
  productId: string | number,
): [any, any[], any] => {
  const { addRequest, removeRequest } = useContext(TrackingRequestContext);
  const [fetchLinkageTemplates, result] = useLazyGetTemplatesQuery();

  const { data: linkageTemplates, onScroll } = useLazyLoadOption({
    fetch: async (pagination) => {
      addRequest(`LinkageTemplate-${productId}`);
      const { data: response }: any = await fetchLinkageTemplates({
        current: pagination.currentPage,
        pageSize: 10,
        status: 'active',
        productProfileId: productId,
      } as any).unwrap();
      removeRequest(`LinkageTemplate-${productId}`);
      return response;
    },
  });

  return [result, linkageTemplates, onScroll];
};
